import type { ReactNode } from "react";
import { Tooltip, useTheme } from "@mui/material";

export function TooltipInfoBox({
  title,
  icon,
}: {
  title: string;
  icon: ReactNode;
}) {
  const theme = useTheme();
  return (
    <Tooltip
      arrow
      data-testid="info-tooltip"
      title={title}
      slotProps={{
        tooltip: {
          sx: {
            maxWidth: "200px",
            backgroundColor: "common.white",
            color: "common.black",
            border: `2px solid ${theme.palette.common.lightGray}`,
          },
        },
        arrow: {
          sx: {
            color: "common.lightGray",
          },
        },
      }}
    >
      <span tabIndex={0} role="img" aria-label={title}>
        {icon}
      </span>
    </Tooltip>
  );
}
